module.exports = __webpack_public_path__ + "static/media/discountCodes.mobile.cf745810.svg";